import { Injectable } from '@angular/core';
import { read, utils } from 'xlsx';

@Injectable({
  providedIn: 'root',
})
export class XlsxToJsonService {
  constructor() {}

  public async xlsxToJson(file: File) {
    try {
      const arrayBuffer: ArrayBuffer = await file.arrayBuffer();
      const uint8Array = new Uint8Array(arrayBuffer);
      const workBook = read(uint8Array, {
        type: 'array',
      });
      const sheetName = workBook.SheetNames[0]; // Since we update only one sheet at a time, we have hardcoded
      const itemsArray: Array<string> = [];
      utils.sheet_to_json(workBook.Sheets[sheetName]).forEach((data: any) => {
        for (const key in data) {
          itemsArray.push(data[key]);
        }
      });
      return itemsArray;
    } catch (error) {
      throw new Error('Error in xlsx parsing service');
    }
  }
}
